import { jsx as _jsx } from "react/jsx-runtime";
import { useBanner, BannerGroup } from "../../..";
import { GroupList } from "../../common";
const BannerGroupList = ()=>{
    const { groups } = useBanner();
    const useGroups = groups.filter((param)=>{
        let { items } = param;
        return items.length;
    });
    return /*#__PURE__*/ _jsx(GroupList, {
        children: useGroups.map((group)=>/*#__PURE__*/ _jsx(BannerGroup, {
                group: group
            }, group.id))
    });
};
export { BannerGroupList };
